export const boxShadows = {
  elevation2: '2px 2px 10px 0 #9d9db44d',
};

export default boxShadows;
